
import BScroll from '@better-scroll/core'
import ScrollBar from '@better-scroll/scroll-bar'
import { onMounted, onUnmounted, watch } from '@vue/runtime-core'
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    isNormal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, ctx) {
    const handleOptionClick = item => {
      // 防止多次点击
      const hasSelected = props.data?.optionVoList.filter(item => item.select)[0]
      if (hasSelected) {
        return
      }
      item.select = true
      const answers = [{
        questionKey: props.data.questionKey,
        answers: [{
          questionKey: props.data.questionKey,
          optionKey: item.optionKey
        }]
      }]
      ctx.emit('submit', answers)
    }

    const { scrollRefresh } = useScrollEffect(props)

    return {
      scrollRefresh,
      handleOptionClick
    }
  }
}

// 初始化滚动条
const useScrollEffect = (props) => {
  BScroll.use(ScrollBar)
  let scroll = null

  const scrollRefresh = () => {
    scroll.refresh()
  }

  watch(props.data, () => {
    scroll.refresh()
  })

  onMounted(() => {
    scroll = new BScroll('.scroll-wrap', {
      scrollY: true,
      scrollbar: {
        interactive: true,
        scrollbarTrackClickable: true
      },
      click: true
    })
  })

  onUnmounted(() => {
    scroll.destroy()
  })

  return {
    scrollRefresh
  }
}
